import React from 'react';

import GalleryDemoLayout from './GalleryDemoLayout';
import GalleryCoverflowCarousel from './GalleryCoverflowCarousel';
import { PHOTOS } from './galleryDemoData';

/* Demo 2 — 3D Coverflow carousel. Centre photo in focus, neighbours tilt
   away in 3D. Arrow keys / buttons / dots to glide; click the centre to zoom.
   Shares GalleryCoverflowCarousel with the live gallery pages so the design
   stays in one place. */
const GalleryCoverflow = () => (
    <GalleryDemoLayout
        demoLabel="Demo 2"
        kicker="3D Coverflow"
        title="Step Into The Frame"
        lead="A cinematic coverflow — the centre photo takes the stage while the rest angle away in 3D. Use the arrows or arrow keys to glide; click the centre photo to open it full-screen."
    >
        <GalleryCoverflowCarousel photos={PHOTOS} />
    </GalleryDemoLayout>
);

export default GalleryCoverflow;
